import readlangClient from "readlangClient";
import translateErrorHandler from "translateErrorHandler";
import * as transliterations from "transliterations";
import * as walkthrough from "walkthrough";

export const getTranslator =
  (options) =>
  async (data, success, errorCallback, transliterationCallback) => {
    let responseData: any;

    try {
      responseData = (
        await readlangClient.request(
          "GET",
          "/api/translate",
          data,
          undefined,
          undefined
        )
      ).data;
    } catch (error) {
      translateErrorHandler(
        error.jqXHR,
        options.models,
        options.notify,
        options.dismissNotification
      );
      errorCallback();
      return;
    }

    success(responseData);
    walkthrough.setAchievement("translate", true);

    if (!(await transliterations.show(data.source))) {
      return;
    }

    // Get transliteration
    const transliteration = await transliterations.fetch(data.source, data.q);

    transliterationCallback(transliteration);
  };
